export const PerioIndexCards = {
  flow: 'x',
  gap: 'Z',
  flexWrap: 'wrap',

  BleedingCard: {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',

    CardLabel: {
      text: '{{ bleedingIndex | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    CardValue: {
      text: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.bleeding
        return (val !== undefined ? val : 18) + '%'
      },
      fontSize: 'D',
      fontWeight: '800',
      color: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.bleeding
        val = val !== undefined ? val : 18
        return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy'
      }
    },

    CardBar: {
      width: '100%',
      height: 'X',
      round: 'X',
      background: 'inkSurface',
      CardFill: {
        width: (el, s) => {
          var val = s.root.perioIndices && s.root.perioIndices.bleeding
          return (val !== undefined ? val : 18) + '%'
        },
        height: '100%',
        round: 'X',
        background: (el, s) => {
          var val = s.root.perioIndices && s.root.perioIndices.bleeding
          val = val !== undefined ? val : 18
          return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy'
        }
      }
    }
  },

  PlaqueCard: {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',

    CardLabel: {
      text: '{{ plaqueIndex | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    CardValue: {
      text: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.plaque
        return (val !== undefined ? val : 24) + '%'
      },
      fontSize: 'D',
      fontWeight: '800',
      color: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.plaque
        val = val !== undefined ? val : 24
        return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy'
      }
    },

    CardBar: {
      width: '100%',
      height: 'X',
      round: 'X',
      background: 'inkSurface',
      CardFill: {
        width: (el, s) => {
          var val = s.root.perioIndices && s.root.perioIndices.plaque
          return (val !== undefined ? val : 24) + '%'
        },
        height: '100%',
        round: 'X',
        background: (el, s) => {
          var val = s.root.perioIndices && s.root.perioIndices.plaque
          val = val !== undefined ? val : 24
          return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy'
        }
      }
    }
  },

  Sites4Card: {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',

    CardLabel: {
      text: '{{ sitesAbove4 | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    CardValue: {
      text: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.sites4
        return String(val !== undefined ? val : 12)
      },
      fontSize: 'D',
      fontWeight: '800',
      color: 'perioWarning'
    },

    CardSub: {
      text: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.sites4
        var total = s.root.perioIndices && s.root.perioIndices.totalSites
        val = val !== undefined ? val : 12
        total = total !== undefined ? total : 192
        return Math.round(val / total * 100) + '% of sites'
      },
      fontSize: 'Y',
      color: 'inkMuted'
    }
  },

  Sites6Card: {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',

    CardLabel: {
      text: '{{ sitesAbove6 | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    CardValue: {
      text: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.sites6
        return String(val !== undefined ? val : 3)
      },
      fontSize: 'D',
      fontWeight: '800',
      color: 'perioCritical'
    },

    CardSub: {
      text: (el, s) => {
        var val = s.root.perioIndices && s.root.perioIndices.sites6
        var total = s.root.perioIndices && s.root.perioIndices.totalSites
        val = val !== undefined ? val : 3
        total = total !== undefined ? total : 192
        return Math.round(val / total * 100) + '% of sites'
      },
      fontSize: 'Y',
      color: 'inkMuted'
    }
  }
}
